module.exports = __webpack_public_path__ + "img/icom6.62029122.png";